export interface Program {
  programId: number;
  displayName: string;
  owner: string;
  status: boolean;
}

export function blankProgram(): Program {
  return {
    displayName: '',
    owner: '',
    programId: 0,
    status: true,
  }
}
